// extracted by mini-css-extract-plugin
export default {"ant-typography":"entityOverview_ant-typography__k18G9","container":"entityOverview_container__ggWfe","alert":"entityOverview_alert__ngwJA","noAlert":"entityOverview_noAlert__-i9QC"};